// import 'dotenv/config';
// import dotenv from 'dotenv';
import * as packagesJson from '../package.json';
// import {stateCities} from '@/constants/cities';
// import type {TStates} from '@/constants/cities';

const nodeEnv = process.env.REACT_APP_NODE_ENV;
// if (nodeEnv === 'development') {
// 	dotenv.config({path: `.env.development`, debug: true});
// } else {
// 	dotenv.config();
// }
const port = process.env.REACT_APP_PORT || '3000';
const version = process.env.REACT_APP_VERSION || '0.0.1';
const name = process.env.REACT_APP_NAME || 'rezvan';
// const apiVERSION = process.env.API_VERSION || packagesJson.version;

type TServer = {
	'host': string,
	'port': number
}
type TConfig = {
	base: {
		url: string,
		name: string,
		version: string
	},
	socket: {
		url: string
	},
	socketCompetition: {
		url: string
	},
	competition: {
		url: string
	},
	competition2: {
		url: string
	},
	dynamisms: {
		url: string
	},
	radio: {
		url: string
	},
	parking: {
		url: string
	},
	logout: {
		url: string
		redirect: string
	},
	analytics: {
		googleV3: string,
		googleV4: string[]
	}
}
type TConstants = {
	// allStates: TStates[]
}
let serverConfig: TServer, appConfig: TConfig, appConstants: TConstants, logs;
serverConfig = {
	host: process.env.REACT_APP_HOST as string,
	port: process.env.REACT_APP_PORT as unknown as number
};
appConfig = {
	base: {
		url: process.env.REACT_APP_BASE_URL as string,
		name: name as string,
		version: version as string
	},
	socket: {
		url: process.env.REACT_APP_SOCKET_URL as string
	},
	socketCompetition: {
		url: process.env.REACT_APP_SOCKET_COMPETITION_URL as string
	},
	competition: {
		url: process.env.REACT_APP_COMPETITION_URL as string
	},
	competition2: {
		url: process.env.REACT_APP_COMPETITION2_URL as string
	},
	dynamisms: {
		url: process.env.REACT_APP_DYNAMISMS_URL as string
	},
	radio: {
		url: process.env.REACT_APP_RADIO_URL as string
	},
	parking: {
		url: process.env.REACT_APP_PARKING_URL as string
	},
	logout: {
		url: process.env.REACT_APP_LOGOUT_URL as string,
		redirect: process.env.REACT_APP_LOGOUT_REDIRECT_URL as string
	},
	analytics: {
		googleV3: process.env.REACT_APP_ANALYTICS_ID as string,
		googleV4: [process.env.REACT_APP_MEASUREMENTS_IDS as string]
	}
};
// appConstants = {
// 	allStates: stateCities
// };

//
// const SEX = {
// 	Male: 0,
// 	Female: 1,
// } as const;
//
// type Sex = typeof SEX[keyof typeof SEX];

// sentry = {
// 	enable: toBoolean(process.env.SENTRY),
// 	dsn: ''
// };
logs = {
	customLevels: {
		levels: {
			trace: 5,
			debug: 4,
			info: 3,
			warn: 2,
			error: 1,
			fatal: 0
		},
		colors: {
			trace: 'white',
			debug: 'green',
			info: 'green',
			warn: 'yellow',
			error: 'red',
			fatal: 'red'
		}
	},
	logLevels: {
		error: 0,
		warn: 1,
		info: 2,
		http: 3,
		verbose: 4,
		debug: 5,
		silly: 6
	},
	level: {
		mehr: 'silly',
		reply: 'http'
	}
};
export {
	packagesJson as packagesJson,
	serverConfig as serverConfig,
	appConfig as appConfig,
	// appConstants as appConstants,
	logs as logs
};
